var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{directives:[{name:"lazyload",rawName:"v-lazyload"}]},[_c('img',{directives:[{name:"lazyload",rawName:"v-lazyload"}],staticClass:"thumbnail",attrs:{"data-url":_vm.source,"alt":"random image"}})])}
var staticRenderFns = []

export { render, staticRenderFns }